import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios"; 
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import DateFieldValidations from "./DateFieldsValidation.jsx";
import TextFieldsValidation from "./TextFieldsValidation.jsx";
import IntegerFieldsValidation from "./IntegerFieldsValidation.jsx";
import { LangContext } from "../LangContext.jsx";
const fieldTypes = [
    {
        id: 'text',
        title: 'Texto',
        icon: 'fa-font'
    },
    {
        id: 'paragraph',
        title: 'Párrafo',
        icon: 'fa-paragraph'
    },
    {
        id: 'date',
        title: 'Fecha',
        icon: 'fa-calendar'
    },
    {
        id: 'number',
        title: 'Número',
        icon: 'fa-number'
    } 
];
class CreateDocumentFields extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            field:props.field,
            title:'',
            placeholder:'',
            id:props.id,
            hasValidation: false,
            type:props.field,
            conditions:[],
            document_field_type:'',
            selectedComponent: '',
            cancelValidation:false,
            master:'',
            isIconUp: false,
        };
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handlePlaceholderChange = this.handlePlaceholderChange.bind(this);
    }
    handleCheckboxChange = (id,state,master) => {
        if(state){
            this.setState( {selectedComponent:id,cancelValidation:state,master:master},function(){
                this.updateParentStates()
            });
        }else{
            this.setState( {selectedComponent:'',master:master},function(){
                this.updateParentStates()
            });
        }
    };
    handleValidationChange = (e) => {
        const value = e.target.value; 
        if(value == 'true'){
            this.setState({ hasValidation: true },function(){
                this.updateParentStates()
            });
        }else{
            this.setState({ hasValidation: false,selectedComponent:'' },function(){this.updateParentStates()});
        }
        
    };

    handleTitleChange(e) { 
        this.setState({ title: e.target.value },function(){
            this.updateParentStates()
        });
    }

    handlePlaceholderChange(e) {
        this.setState({ placeholder: e.target.value });
    }

    componentDidMount() { 
        this.setState({'document_field_type':this.props.document_field_type})
        this.setState({'title':this.props.title})
        this.setState({'placeholder':this.props.placeholder})
        if (this.props.conditions) {
            if(this.props.conditions.length > 0){
                this.setState({hasValidation:true})
            }
        }
        
        this.setState({conditions:this.props.conditions},function(){
            this.updateParentStates()
        })
        
    }
   
    updateParentStates = () => { 
        const allChildStates = { ...this.state }; 
        this.props.updateParentState(allChildStates);
    }

    
    updateValidationState = (updatedState) => { 
        this.setState({ conditions: updatedState.conditions },function(){
            this.updateParentStates()
        });
        return;
        const { id } = updatedState; 
        this.setState((prevState) => ({
            fields: prevState.fields.map((field) =>
                field.id === id ? { ...field, ...updatedState } : field
            ),
        }));
    }
    handleDelete = () => {
        const { id, deleteField } = this.props;  
        if(this.state.selectedComponent != ''){ 
            this.setState({selectedComponent:''},function(){ 
                deleteField(id);
                this.updateParentStates()
                
            }) 
        }else{
            deleteField(id);
        }  
    };

    getIconForType(typeId) {
        for (const t of fieldTypes) {
            if (typeId == t.id) {
                return t.icon;
            }
        }
    }
    handleToggleIcon = () => {
        this.setState((prevState) => ({
            isIconUp: !prevState.isIconUp,
        }));
    };
    translate(tipo) {
            switch (tipo) {
            case 'number':
                return 'Número';
            case 'text':
                return 'Texto';
            case 'paragraph':
                return 'Párrafo';
            case 'date':
                return 'Fecha';
            default:
                return tipo; // Si no es ninguno de los anteriores, devolver el valor original
    }
  }
    render() {
        const { lang } = this.context; 
        const { hasValidation } = this.state;
        const { isIconUp } = this.state;
        const iconClass = isIconUp ? "flaticon2-up" : "flaticon2-down";
        return (
            <> 
                <div   className="card-custom  mb-3">
                    <div  >
                        <div className="headContainer" >
                            <div className=" " id="headingOne">
                            {this.props.document_field_type == 'number' &&
                                    <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.63202 19.9948C4.6268 19.8959 4.62159 19.8022 4.62159 19.7034C4.62159 15.6232 4.62159 11.5483 4.62159 7.46812C4.62159 7.38486 4.62159 7.30159 4.62159 7.21832C4.52248 7.1975 4.47553 7.26516 4.42337 7.30679C3.14017 8.24356 1.71093 8.87328 0.203441 9.34686C0.0365213 9.39891 0 9.34686 0 9.19074C0.00521623 7.81681 0.00521623 6.44809 0 5.07416C0 4.90762 0.0782486 4.85558 0.213871 4.80874C1.73179 4.30913 3.02021 3.44523 4.13126 2.3159C4.71548 1.72261 5.12756 1.02004 5.38837 0.228988C5.44575 0.057247 5.524 0 5.70656 0C6.85935 0.0104085 8.01213 0.0104085 9.17014 0C9.37357 0 9.42052 0.0624512 9.42052 0.255009C9.4153 6.77075 9.4153 13.2917 9.4153 19.8074C9.4153 19.8699 9.40487 19.9375 9.40487 20C7.81392 19.9948 6.22297 19.9948 4.63202 19.9948Z" fill="#C2C2C2"/>
                                </svg>
                                    }
                                <i className={`fa ${this.getIconForType(this.props.document_field_type)} icon w-30px`}></i>
                                {lang.get('messages.'+this.translate(this.state.document_field_type).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""))}
                                <a  data-toggle="collapse"  onClick={this.handleToggleIcon} data-target={`#collapse${this.props.id}`}
                                                aria-expanded="false" aria-controls="collapseOne"   target="_blank"   className="float-right mr-1 btn btn-icon btn-secondary btn-xs mr-2 visor-button">
                                    <i className={`${iconClass} text-primary`}></i>
                                </a>
                                <a onClick={(e) => this.handleDelete(this.props.id)} className="float-right mr-1 btn btn-icon btn-secondary btn-xs mr-2 visor-button">
                                    <i class="flaticon-delete text-primary"></i>
                                </a>
                            </div>
                        </div>
                        <div id={`collapse${this.props.id}`} className="collapse show p-5" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div className="row justify-content-center text-left">
                                <div className="col-sm-4 align-self-center">
                                <strong>{lang.get('messages.propiedades_del_campo')}</strong><br/>
                                    <label className="text-left">{lang.get('messages.nombre')}</label>
                                    <input id="name" type="text" className="form-control" name="name" 
                                        value={this.state.title} 
                                        onChange={this.handleTitleChange}
                                    />
                                </div> 
                                <div className="col-sm-4 align-self-center mt-6">
                                    <label className="text-left">{lang.get('messages.ayuda')}</label>
                                    <input id="placeholder" type="text" className="form-control" name="placeholder" 
                                        value={this.state.placeholder} 
                                        onChange={this.handlePlaceholderChange}
                                    />
                                </div> 
                                <div className="col-sm-4 align-self-center mt-6">
                                    <label className="text-left">{lang.get('messages.validacion_automatica')}</label>
                                    <div class="d-flex ">
                                        <div class=" d-flex">
                                            <div class="col-md-8  font-size-h4 selectedRadio">
                                                <input type="radio" value={true} checked={hasValidation == true}
                                                    onChange={this.handleValidationChange}  /> {lang.get('messages.si')}
                                            </div>
                                            <div class="col-md-8 font-size-h5 text-dark ">
                                                <input type="radio" value={false} checked={hasValidation == false}
                                                    onChange={this.handleValidationChange} /> {lang.get('messages.no')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 ">
                            {this.state.hasValidation && (
                                <div>
                                <strong>{lang.get('messages.condiciones_de_validacion_automatica')}</strong>
                                {(() => {
                                    switch (this.state.document_field_type) {
                                    case 'text':
                                        return <TextFieldsValidation conditions={this.state.conditions} fieldName={this.state.title} updateValidationState={this.updateValidationState} />;
                                    case 'paragraph':
                                        return <TextFieldsValidation conditions={this.state.conditions} fieldName={this.state.title} updateValidationState={this.updateValidationState} />;
                                    case 'date':
                                        return <DateFieldValidations
                                        conditions={this.state.conditions}
                                        onCheckboxChange={(state,master) => this.handleCheckboxChange(this.props.id,state,master)}
                                        id={this.props.id}
                                        dateValidationComponent={this.props.dateValidationComponent}
                                        document={this.props.document}
                                        fieldName={this.state.title} updateValidationState={this.updateValidationState} />;
                                    case 'number':
                                        return <IntegerFieldsValidation fieldName={this.state.title}  conditions={this.state.conditions} updateValidationState={this.updateValidationState} />;
                                    default:
                                        return null;
                                    }
                                })()}
                                </div>
                            )}
                            </div>
                        </div> 
                    </div>
                </div> 
            </>
        );
    }
}

export default CreateDocumentFields;

if (document.getElementById('CreateDocumentFields')) {
    ReactDOM.render(<CreateDocumentFields />, document.getElementById('CreateDocumentFields'));
}
